module.exports = __webpack_public_path__ + "assets/img/whitegradient.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/whitegradient.png
// module id = 1994
// module chunks = 0